module.exports = __webpack_public_path__ + "static/img/reservation_icon.23b0af6a.svg";